export default {
  label: 'Text Field',
  placeholder: '',
  description: '',
  tooltip: '',
  customClass: '',
  hidden: false,
  hideLabel: false,
  disabled: false,
  key: 'textfield',
  defaultValue: {
    type: 'value',
    value: ''
  },
  validate: {
    required: false
  },
  type: 'textfield',
  input: true,
  isNew: true,
  amsField: ''
};
